import * as R from 'ramda'
import moment from 'moment'
import {
  DEPARTURE_DATE_RANGE_SHORT_FORMAT,
  DEPARTURE_DATE_RANGE_SHORT_FORMAT_WITHOUT_YEAR
} from 'constants/dateFormats'
import {
  DELAYED_PAYMENT_TYPES,
  PAYMENT_METHOD_ALMA_LABEL,
  PAYMENT_METHOD_FLOA3X4X_LABEL,
  PAYMENT_METHOD_FLOA4X_LABEL,
  PAYMENT_METHOD_ONEY_LABEL,
  PAYMENT_METHOD_PLEDG_LABEL
} from 'constants/paymentMethods'
// import type {
//   FiltersProducts,
//   PackageResource,
//   PaymentBannerType,
//   PaymentMethod,
//   PaymentMethods,
//   ProductResource,
//   ProductResourceWithPosition,
//   ResourcePrice
// } from 'types'

export const getProductPosition = R.pipe(
  R.prop('position'),
  R.defaultTo(0)
)
export const getProductCallPrice = R.pipe(
  R.path(['ecomm', 'price', 'price']),
  R.defaultTo(0)
)
export const getProductSourceKey = R.path(['ecomm', 'externalId'])
export const getProductTitle = R.path(['content', 'title'])

/*
  The `undefined` check of the hasPrice is here for retrocompat issue
  it should be removed in the future
*/
export const getProductPrice = R.curry((filtersProducts, product) => {
  const filteredProduct = filtersProducts[product.key]

  if (filteredProduct !== undefined) {
    return (
      (filteredProduct.hasPrice || filteredProduct.hasPrice === undefined)
        ? R.pick(['price', 'msrp', 'unit'], filteredProduct)
        : null
    )
  }

  return (
    (product.ecomm.hasPrice || product.ecomm.hasPrice === undefined)
      ? R.path(['ecomm', 'price'], product)
      : null
  )
})

export const getProductPriceTypeLabel = (
  filtersProducts,
  product
) => {
  const filteredProduct = filtersProducts[product.key]

  return filteredProduct !== undefined
    ? (filteredProduct?.priceTypeLabel || filteredProduct?.ecomm?.priceTypeLabel)
    : (product?.priceTypeLabel || product?.ecomm?.priceTypeLabel)
}

/*
  The `undefined` check of the hasPrice is here for retrocompat issue
  it should be removed in the future
*/
export const getPackagePrice = (
  filtersProducts,
  productKey,
  packageResource
) => {
  const currentProduct = filtersProducts[productKey]

  if (currentProduct?.packages?.length > 0) {
    const foundPackage = currentProduct.packages.find(({ packageKey }) => packageKey === packageResource.key)

    if (foundPackage !== undefined) {
      return (
        /* product.ecomm.hasPrice === undefined is for the retrocompatibility, should be removed in the future */
        (foundPackage.hasPrice || foundPackage.hasPrice === undefined)
          ? R.pick(['price', 'msrp', 'unit'], foundPackage)
          : null
      )
    }
  }

  return (
    (packageResource.ecomm.hasPrice || packageResource.ecomm.hasPrice === undefined)
      ? R.path(['ecomm', 'price'], packageResource)
      : null
  )
}

export const getPackagePriceTypeLabel = (
  filtersProducts,
  productKey,
  packageResource
) => {
  const currentProduct = filtersProducts[productKey]

  if (currentProduct?.packages?.length > 0) {
    const foundPackage = currentProduct.packages.find(({ packageKey }) => packageKey === packageResource.key)

    return foundPackage?.priceTypeLabel || foundPackage?.ecomm?.priceTypeLabel
  }

  return packageResource?.priceTypeLabel || packageResource?.ecomm?.priceTypeLabel
}

// type GetIsPaymentBannerDisplayable = (boolean, ProductResource) => boolean
export const getIsPaymentBannerDisplayable = (isPaymentBannerFeatureEnabled, product) => {
  if (isPaymentBannerFeatureEnabled) {
    const paymentMethods = R.path(['ecomm', 'paymentType'], product) || []

    return (Boolean(paymentMethods.find(({ key }) => (
      key === PAYMENT_METHOD_ALMA_LABEL ||
      key === PAYMENT_METHOD_FLOA3X4X_LABEL ||
      key === PAYMENT_METHOD_FLOA4X_LABEL ||
      key === PAYMENT_METHOD_ONEY_LABEL ||
      key === PAYMENT_METHOD_PLEDG_LABEL
    ))))
  }

  return false
}

// type GetPaymentTypeForPaymentBanner = PaymentMethods => ?PaymentBannerType
export const getMostImportantDelayedPaymentType = paymentType => (
  paymentType.reduce((acc, payment) => {
    const hasPaymentTypePriority = (acc === PAYMENT_METHOD_ONEY_LABEL)

    if (hasPaymentTypePriority) {
      return (acc)
    }

    return (
      (payment.key in DELAYED_PAYMENT_TYPES)
        ? payment.key
        : acc
    )
  }, undefined)
)

export const getFormattedDepartureDatesRange = (range, p) => {
  const startingDate = moment(range.from)

  if (!range.to) {
    return `${p.tc('departure_dates_range.unique_departure', {
      from: startingDate.format(p.t('departure_dates_range.unique_date_format'))
    })}`
  }

  const endingDate = moment(range.to)

  if (startingDate.month() === endingDate.month() && startingDate.year() === endingDate.year()) {
    return `${p.tc('departure_dates_range.departure_in', {
      from: startingDate.format(DEPARTURE_DATE_RANGE_SHORT_FORMAT)
    })}`
  }

  if (startingDate.year() === endingDate.year()) {
    return `${p.tc('departure_dates_range.departure_range', {
      from: startingDate.format(DEPARTURE_DATE_RANGE_SHORT_FORMAT_WITHOUT_YEAR),
      to: endingDate.format(DEPARTURE_DATE_RANGE_SHORT_FORMAT)
    })}`
  }

  return `${p.tc('departure_dates_range.departure_range', {
    from: startingDate.format(DEPARTURE_DATE_RANGE_SHORT_FORMAT),
    to: endingDate.format(DEPARTURE_DATE_RANGE_SHORT_FORMAT)
  })}`
}

export const getLabelsFormattedForTracking = (labels) => (
  labels.reduce((acc, label) => {
    const key = `Label ${label.key}`

    if (acc[key] === undefined) {
      acc[key] = []
    }

    acc[key].push(...label.values.map((labelValue) => `${label.linkId}:${labelValue.id}`))
    acc[key] = R.uniq(acc[key])

    return acc
  }, {})
)
